// removed by extract-text-webpack-plugin
module.exports = {"searchHeaderSection":"_1Rc5W"};